import { atomFamily } from 'recoil';
import { recoilPersist } from 'recoil-persist';

import { UserType } from '@constants_common';

const { persistAtom } = recoilPersist();

export const sideMenuScrollPositionAtomFamily = atomFamily<number, UserType>({
  key: 'sideMenuScrollPositionAtomFamily',
  default: 0,
  effects_UNSTABLE: [persistAtom],
});
